import { setCookie } from '@ecster/cookies';

const currency = {
    FI: 'EUR',
    SE: 'SEK',
};

// t.o.d.o: is this one ever called? /joli44 2026 05
export const changeLanguage = async locale => {
    const [lang, country] = locale.split('-');
    setCookie('locale', locale, 365);
    window.EcsterConfig.language = lang;
    window.EcsterConfig.currency = currency[country];
    window.EcsterConfig.locale = locale;
    document.querySelector('html').setAttribute('lang', locale);
};
